<template>
  <b-card>
    <!-- Header: Personal Info -->
    <div class="d-flex">
      <feather-icon
        icon="UserIcon"
        size="19"
      />
      <h4 class="mb-0 ml-50">
        {{ $t('Roles') }}
      </h4>
    </div>

    <!-- Form: Personal Info Form -->
    <b-form class="mt-1">
      <b-row class="mt-2">
        <b-col
          cols="12"
          md="4"
        >
          <b-form-group>
            <b-badge
              v-for="item in userData.roles"
              :key="item.id"
              pill
              variant="light-success mr-1 mb-1"
            >
              {{ item.display_name }}
            </b-badge>
          </b-form-group>
        </b-col>
      </b-row>
      <!-- PERMISSION TABLE -->
      <b-card
        no-body
        class="border mt-1"
      >
        <b-card-header class="p-1">
          <b-card-text>
            <feather-icon
              icon="LockIcon"
              size="16"
            />
            <span class="align-middle ml-50">{{ $t('Permission') }}</span>
          </b-card-text>
        </b-card-header>
        <b-card-body>
          <b-card-text>
            Các quyền được cấp theo vai trò.
          </b-card-text>
          <b-input-group class="my-2">
            <b-form-input
              v-model="searchPermQuery"
              class="d-inline-block"
              placeholder="Từ khóa"
              @keydown.enter="searchPerm($event)"
            />
            <b-input-group-append>
              <b-button
                variant="primary"
                @click.prevent.stop="searchPerm"
              >
                <feather-icon icon="SearchIcon" />
              </b-button>
            </b-input-group-append>
          </b-input-group>
          <b-card-group
            :columns="currentBreakPoint === 'md' || currentBreakPoint === 'lg' || currentBreakPoint === 'xl'"
            :deck="currentBreakPoint === 'xs' || currentBreakPoint === 'sm'"
          >
            <b-card
              v-for="item in listPermissions"
              v-if="isShowModule(item)"
              :key="`module_${item.id}`"
              :title="item.description"
              class="border"
            >
              <b-form-group>
                <div
                  v-for="pem in item.permissions"
                  :key="`pem_${pem.id}`"
                  class="d-flex"
                >
                  <template v-if="isShowPerm(pem.id)">
                    <div class="text-success">
                      <feather-icon
                        icon="CheckCircleIcon"
                        size="18"
                      />
                    </div>
                    <p class="mb-1 ml-50 text-black">
                      {{ `${pem.description} (${pem.name})` }}
                    </p>
                  </template>
                </div>

              </b-form-group>
            </b-card>
          </b-card-group>
        </b-card-body>
      </b-card>

    </b-form>
  </b-card>
</template>

<script>
import {
  BRow, BCol, BForm, BFormGroup, BBadge, BCard, BCardHeader, BCardText, BTable,
  BInputGroup,
  BInputGroupAppend,
  BFormInput,
  BButton,
  BCardGroup,
  BCardBody,
} from 'bootstrap-vue'

export default {
  components: {
    BRow,
    BCol,
    BForm,
    BFormGroup,
    BBadge,
    BCard,
    BTable,
    BCardHeader,
    BCardText,
    BButton,
    BInputGroup,
    BFormInput,
    BInputGroupAppend,
    BCardGroup,
    BCardBody,
  },
  props: ['userData'],
  data() {
    return {
      loading: false,
      searchPermQuery: '',
      searchPermIds: [],
      searchModuleIds: [],
      userId: 0,
      roleIds: [],
      // listPermissions: [],
      rolesData: [],
      fields: [
        {
          key: 'name',
          label: 'Quyền',
          sortable: true,
        },
        {
          key: 'description',
          label: 'Diễn giải',
          sortable: false,
        },

      ],
    }
  },
  computed: {
    listPermissions() {
      // console.log('this.userData.modules', this.userData.modules);
      return this.userData ? this.userData.modules : null;
    },
    currentBreakPoint() {
      return this.$store.getters['app/currentBreakPoint'];
    },
  },
  methods: {
    isShowModule(mod) {
      if (this.searchPermQuery === '') {
        return true;
      }
      return this.searchModuleIds.find((val) => val === mod.id) && mod.permissions.length;
    },
    isShowPerm(permId) {
      if (this.searchPermQuery === '') {
        return true;
      }
      return this.searchPermIds.find((val) => val === permId);
    },
    searchPerm(e) {
      e.preventDefault();
      e.stopPropagation();
      this.searchPermIds = [];
      this.searchModuleIds = [];
      this.listPermissions.forEach(mod => {
        mod.permissions.forEach(per => {
          if (per.name.toLowerCase().indexOf(this.searchPermQuery) > -1 || per.description.toLowerCase().indexOf(this.searchPermQuery) > -1) {
            this.searchPermIds.push(per.id);
            this.searchModuleIds.push(mod.id);
            // console.log(per.name, mod.name, mod.id);
          }
        });
      });
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>
